import { type NuxtAxiosInstance } from '@/types/axios'
import type { VerifyPromoCodePayload, GetMemberElitePayload, RequestElitePayload, VerifyElitePayload } from '@/view-models/member'

export async function updateMemberRegion(axios: NuxtAxiosInstance, regionId: string | number): Promise<void> {
  await axios.$post(`/member/region/${regionId}`).catch((err: Error) => console.log('updateMemberRegion errors, error is: ', err))
}

export async function getPromoCodes(axios: NuxtAxiosInstance) {
  const res = await axios.$get('/promo', { headers: { APIVer: 2 } })

  if (res.code !== 0) {
    throw res
  }

  return res
}

export async function verifyPromoCode(axios: NuxtAxiosInstance, payload: VerifyPromoCodePayload) {
  const res = await axios.$post('/promo', payload)

  return res
}

/**
 * @doc https://github.com/myfunnow/funnow-api-doc/blob/959d84d78c0e1212531d77c39c700fa6dfb68e08/docs/elite.md#%E5%8F%96%E5%BE%97-elite-%E6%AC%8A%E7%9B%8A%E7%8B%80%E6%85%8B
 */
export async function getMemberElite(axios: NuxtAxiosInstance, params: GetMemberElitePayload) {
  const res = await axios.$get('/member/elite', { params }).catch(err => {
    console.log('getMemberElite err, err is: ', err)
  })

  return res?.data || {}
}

/**
 * @doc https://github.com/myfunnow/funnow-api-doc/blob/959d84d78c0e1212531d77c39c700fa6dfb68e08/docs/elite.md#%E7%94%B3%E8%AB%8B-elite-%E6%AC%8A%E7%9B%8A
 */
export async function requestElite(axios: NuxtAxiosInstance, payload: RequestElitePayload) {
  const res = await axios.$post('/member/elite/request', payload)

  return res
}

/**
 * @doc https://github.com/myfunnow/funnow-api-doc/blob/959d84d78c0e1212531d77c39c700fa6dfb68e08/docs/elite.md#%E9%A9%97%E8%AD%89-elite-%E7%94%B3%E8%AB%8B
 */
export async function verifyElite(axios: NuxtAxiosInstance, payload: VerifyElitePayload) {
  const res = await axios.$post('/member/elite/verify', payload)

  if (res.code !== 0) {
    throw res
  }

  return res
}
